module.exports = __webpack_public_path__ + "img/25-Hair.06b70c1c.png";